var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container flex flex-col justify-center"},[_c('h1',{staticClass:"heading-1 py-2 text-center"},[_vm._v(_vm._s(_vm.$t('error.title')))]),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('error.content')))])])}
var staticRenderFns = []

export { render, staticRenderFns }